import { AdminRouterProvider } from "@app/router";

export { adminClient } from "@app/adminClient";
export { rootRoute } from "@app/router/rootRoute";

export function App() {
  return <AdminRouterProvider />;
}
